export { default as Rating } from './Rating'
